
export const mentalWellnessData = {
  scores: {
    stress: 65,
    burnoutRisk: 55,
    creativity: 78,
    workLifeBalance: 42
  },
  insights: [
    {
      title: "Stress Management",
      description: "Your stress levels have increased by 15% in the past month, coinciding with your increased app usage and frequency of uploads.",
      recommendations: [
        "Schedule 2-3 tech-free breaks during your workday",
        "Try the 5-minute mindfulness exercise daily",
        "Consider pushing back non-essential deadlines"
      ]
    },
    {
      title: "Creativity Cycles",
      description: "Based on your activity patterns in the app, your most creative periods come after taking breaks. Your most productive uploads follow periods of rest.",
      recommendations: [
        "Block off 'creative reset' time twice weekly",
        "Experiment with working during your identified peak creativity hours (2pm-5pm)",
        "Try changing your environment when feeling blocked"
      ]
    }
  ],
  recentActivities: [
    { name: 'Creative Reset', date: '2 days ago', impact: 'Positive' as const },
    { name: 'Mindfulness Session', date: '1 week ago', impact: 'Positive' as const },
    { name: 'Long Work Session', date: '3 days ago', impact: 'Negative' as const }
  ]
};
